export default __webpack_public_path__ + "static/media/2.37e518c2.png";